import { render, staticRenderFns } from "./AspectRatio.vue?vue&type=template&id=61a5a924&scoped=true&"
import script from "./AspectRatio.vue?vue&type=script&lang=js&"
export * from "./AspectRatio.vue?vue&type=script&lang=js&"
import style0 from "./AspectRatio.vue?vue&type=style&index=0&id=61a5a924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a5a924",
  null
  
)

export default component.exports